module.exports = __webpack_public_path__ + "static/media/choithramsPetFoodS.f72d6d20.png";